import type { Profile, ProfilesState } from '@/types';
import type { AuthState } from '@b2x/authentication';
import { deepFreeze } from '@b2x/shared';

export const PROFILES_STATE_STORAGE_KEY = 'swsp:PROFILES_STATE';
export const ACTIVE_PROFILE_STORAGE_KEY = 'swsp:ACTIVE_PROFILE';
export const PROFILES_STATE_BROADCAST_CHANNEL = 'PROFILES_STATE_BROADCAST_CHANNEL';

export const BUSINESS_TYPE = Object.freeze({
  B2B: 'B2B',
  B2C: 'B2C',
} as const);

export const STATUS = Object.freeze({
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  INITIAL: 'INITIAL',
} as const);

export const EMPTY_PROFILE: Readonly<Profile> = deepFreeze({
  id: null,
  displayName: null,
  customerGroupId: null,
  market: null,
  customerType: null,
  businessType: null,
});

export const EMPTY_PROFILES_STATE: Readonly<ProfilesState> = deepFreeze({
  activeProfile: EMPTY_PROFILE,
  availableProfiles: [],
  meta: {
    status: STATUS.INITIAL,
    message: 'No profiles',
  },
});

export const EMPTY_AUTH_STATE: Readonly<AuthState> = deepFreeze({
  email: null,
  jwe: null,
  isLoggedIn: false,
  isMfaEnabled: false,
});
